import type { FC } from "react";
import type { IPrivateText } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import { SharingOption } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/SharingOption";
import type { ISharingType } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/types";

interface IPrivate extends ISharingType {
    text: IPrivateText;
}

export const Private: FC<IPrivate> = (props) => {
    const { sharingState, setSharingState, text, isDisabled } = props;
    const { title, subtitle } = text;
    return (
        <SharingOption
            onClick={() => setSharingState(ESharingState.PRIVATE)}
            isSelected={sharingState === ESharingState.PRIVATE}
            iconName={"impressions--off"}
            title={title}
            subTitle={subtitle}
            isDisabled={isDisabled}
        />
    );
};
